/**
 * Created by tmorone on 2/11/2016.
 */

var Backbone = require('backbone');
var App = require('../app.js');

module.exports = Backbone.Model.extend({
    urlRoot: '',
    IsLoggedIn: false,

    initialize: function() {
        this.IsLoggedIn = !!this.attributes.id;
    },

    onFBStatus: function(event) {
        App.Logger.debug('fbStatus: ' + JSON.stringify(event));
    }
});
